import ApiService from '@services/api.service';
import { Notify } from 'quasar';
export const etudiantSuivis = {
  state: {
    etudiantSuivi: null,
    etudiantSuivis: [],
    suivisCount: null,
  },
  mutations: {
    setEtudiantSuivi(state, etudiantSuivi){
      state.etudiantSuivi = etudiantSuivi;
    },
    setEtudiantSuivis(state, etudiantSuivis){
      state.etudiantSuivis = etudiantSuivis
    },
    setSuivisCount(state, count){
      state.suivisCount = count;
    }
  },
  actions: {
    async fetchAllSuivisCount(context){
      try{
        const response = await ApiService.getRequest('get_all_etudiant_interview');
        context.commit('setSuivisCount', response .data)
      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est porduite lors de la récupération des données",
          color: 'red'
        })
      }
    },

    async editEtatSuivi(context, data){
      try{
        const response = await ApiService.postRequest(data.url, {etat: data.etat});
        context.commit('setEtudiantSuivi', response.data);
      }catch(error){
        console.error(error);
        Notify.create({
          message:"Une erreur s'est produite",
          color: "red"
        })
      }
    },
  },
  getters: {
    getEtudiantSuivi(state){
      return state.etudiantSuivi;
    },
    getEtudiantSuivis(state){
      return state.etudiantSuivis;
    },
    getSuivisCount(state){
      return state.suivisCount;
    }
  }
}
